export default "__VITE_ASSET__BB05k_mT__"